import React, {Component} from "react"
import {Image, Row, Col} from "react-bootstrap"
import { NavLink } from "react-router-dom"
import '../styles/Colour_Style.css'
import '../styles/Form_Style.css'

class Unauthorized extends Component{
    render(){
        return(
            <div>
                <div className="unauthorize-container">
                    <Row>
                        <Col id="logo-unauthorized" sm={4}>
                            <Image src="assets/logo/mkm-transparent.png"/>
                        </Col>
                        <Col sm={7} style={{display:"flex", justifyContent:"center", alignItems:"center", marginLeft:"20px"}}>
                            <NavLink to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <h1 style={{fontSize:"5vh"}}>401<br/>Unauthorized</h1>
                            </NavLink>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}
export default Unauthorized;